// extracted by mini-css-extract-plugin
export default {"root":"TemperatureImagesPage_root__2aqfk","image-results":"TemperatureImagesPage_image-results__JurIe","fallback":"TemperatureImagesPage_fallback__Zbq7i"};